// extracted by mini-css-extract-plugin
export var background = "section-module--background--7af94";
export var filter = "section-module--filter--f6e86";